import palette from '@lib/core/src/theme/palette';
import { Button, Stack, styled } from '@mui/material';

const GAP = 2; // VH
const QUARTER_PAGE_MIN_HEIGHT = '26vh';
const FULL_PAGE_WIDTH = 1400;

const HALF_PAGE_HEIGHT = 10 + GAP; //vh
const MIN_HALF_PAGE_HEIGHT = `calc(${QUARTER_PAGE_MIN_HEIGHT} * 2 + ${GAP}vh)`;

const CARD_BACKGROUND_COLOR = palette.white;
const CARD_BORDER_RADIUS = '24px';

export const BORDER = `1px solid ${palette.grey[1200]}`;

export const HomeContainer = styled(Stack)({
  position: 'relative',
  alignItems: 'center',
  width: '100%',
  margin: '0 auto',
  overflow: 'auto',
  gap: `5vh`,
  maxWidth: FULL_PAGE_WIDTH
});

export const GreetingAndChat = styled(Stack)({
  width: '100%',
  alignItems: 'center',
  gap: `${GAP}vh`,
  maxWidth: '520px',
  overflow: 'visible'
});

export const TasksCalendarMeetings = styled(Stack)({
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
  width: '100%',
  gap: `${GAP}vh`
});

export const CalendarAndMeetings = styled(Stack)(({ theme }) => ({
  gap: `${GAP}vh`,
  width: '100%',
  height: `${HALF_PAGE_HEIGHT}vh`,
  minHeight: MIN_HALF_PAGE_HEIGHT,
  [theme.breakpoints.up('lg')]: {
    width: `calc(50% - ${GAP / 2}vh)`
  }
}));

export const TasksContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    width: `calc(50% - ${GAP / 2}vh)`
  },
  minHeight: MIN_HALF_PAGE_HEIGHT,
  height: `${HALF_PAGE_HEIGHT}vh`,
  backgroundColor: CARD_BACKGROUND_COLOR,
  borderRadius: CARD_BORDER_RADIUS,
  padding: '22px 0',
  border: BORDER
}));

export const CalendarContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  minHeight: QUARTER_PAGE_MIN_HEIGHT,
  backgroundColor: CARD_BACKGROUND_COLOR,
  borderRadius: CARD_BORDER_RADIUS,
  height: `calc(50% - ${GAP / 2}vh)`,
  border: BORDER
}));

export const MeetingsContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  minHeight: QUARTER_PAGE_MIN_HEIGHT,
  backgroundColor: CARD_BACKGROUND_COLOR,
  borderRadius: CARD_BORDER_RADIUS,
  height: `calc(50% - ${GAP / 2}vh)`,
  border: BORDER
}));

export const ViewAllButton = styled(Button)({
  marginLeft: '8px',
  fontSize: '11px',
  fontWeight: 500,
  color: palette.grey[400],
  cursor: 'pointer',
  textTransform: 'none',
  borderRadius: '16px',
  '&:hover': {
    backgroundColor: palette.grey[100]
  }
});
